import { updateAllHeaderCustomProperties } from '@theme/utilities';

const transparentHeaderState = (window.drKieuTransparentHeaderState ??= {
  originalStyles: new Map(),
  owner: null,
});

class DrKieuBanner extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-transparent-header') || !this.#isFirstMainSection()) return;

    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) return;

    if (transparentHeaderState.owner === null) {
      for (const property of this.#transparentColorProperties) {
        transparentHeaderState.originalStyles.set(property, header.style.getPropertyValue(property));
      }
    }

    transparentHeaderState.owner = this.dataset.sectionId ?? this.id;
    header.dataset.drKieuBannerTransparentOwner = transparentHeaderState.owner;
    header.setAttribute('data-dr-kieu-banner-transparent', '');

    this.#setHeaderColor(header, '--color-transparent-text', this.dataset.transparentHeaderText);
    this.#setHeaderColor(header, '--color-transparent-text-rgb', this.dataset.transparentHeaderTextRgb);
    this.#setHeaderColor(
      header,
      '--color-transparent-text-contrast',
      this.dataset.transparentHeaderTextContrast
    );

    updateAllHeaderCustomProperties();
  }

  disconnectedCallback() {
    const owner = this.dataset.sectionId ?? this.id;
    if (transparentHeaderState.owner !== owner) return;

    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) return;

    for (const property of this.#transparentColorProperties) {
      const originalValue = transparentHeaderState.originalStyles.get(property);
      if (originalValue) {
        header.style.setProperty(property, originalValue);
      } else {
        header.style.removeProperty(property);
      }
    }

    delete header.dataset.drKieuBannerTransparentOwner;
    header.removeAttribute('data-dr-kieu-banner-transparent');
    transparentHeaderState.originalStyles.clear();
    transparentHeaderState.owner = null;
    updateAllHeaderCustomProperties();
  }

  get #transparentColorProperties() {
    return [
      '--color-transparent-text',
      '--color-transparent-text-rgb',
      '--color-transparent-text-contrast',
    ];
  }

  #isFirstMainSection() {
    const section = this.closest('#MainContent > .shopify-section');
    return section !== null && section === document.querySelector('#MainContent > .shopify-section:first-child');
  }

  #setHeaderColor(header, property, value) {
    if (value) header.style.setProperty(property, value);
  }
}

if (!customElements.get('dr-kieu-banner')) {
  customElements.define('dr-kieu-banner', DrKieuBanner);
}
